import { generateGruserObjectId } from '../helpers';
import { Gruser } from '../../types/papi';
import { createSelector } from 'reselect';

export const getCurrentGruserSlice = createSelector(
  state => state['@@gruser'],
  (_: any, gruser: Gruser | undefined) => gruser,
  (state, gruser) => {
    if (!gruser) {
      return {};
    }
    return state.grusers[generateGruserObjectId(gruser)];
  }
);
